import axios from "@/plugins/axios";

let url = "/api/v1/company/employment/forms/signed";

export default {
    delete(data) {
        return axios.delete(`${url}/${data._id}`).then((result) => result.data);
    },
};
